export const normalizeIndianPhone = (phone) => {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.length >= 12 && digits.startsWith('91')) return `+${digits}`;
  if (digits.length === 10) return `+91${digits}`;
  return digits ? `+${digits}` : '';
};

export const maskPhone = (phone) => {
  const digits = String(phone || '').replace(/\D/g, '');
  const local = digits.length >= 12 && digits.startsWith('91')
    ? digits.slice(2, 12)
    : digits.slice(-10);
  if (local.length !== 10) return phone || '—';
  return `+91 ${local.slice(0, 2)}XX XX${local.slice(6)}`;
};

export const phoneTelHref = (phone) => {
  const normalized = normalizeIndianPhone(phone);
  return normalized ? `tel:${normalized}` : null;
};
